import { render } from "./homeAiInstructor.vue?vue&type=template&id=12851067&scoped=true"
import script from "./homeAiInstructor.vue?vue&type=script&lang=js"
export * from "./homeAiInstructor.vue?vue&type=script&lang=js"

import "./homeAiInstructor.vue?vue&type=style&index=0&id=12851067&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12851067"]])

export default __exports__